import { ArrowIcon } from "../../../assets/icons";

type Props = {
  name: string;
  licenseNumber: string;
  licensingAuthority: string;
  selected?: boolean;
};

const CompanyProfileCard: React.FC<Props> = ({
  name,
  licenseNumber,
  licensingAuthority,
  selected = false,
}) => {
  return (
    <div className="cx-w-full cx-rounded-base cx-py-4 cx-px-4 cx-bg-background-default cx-cursor-pointer cx-flex cx-flex-row cx-justify-between cx-items-center cx-gap-3 cx-border-1.5">
      <div className="cx-flex cx-flex-col cx-gap-1 cx-flex-1 cx-min-w-0">
        <div className="cx-flex">
          <p className="cx-text-left cx-font-medium cx-w-full cx-break-words">
            {name}
          </p>
        </div>
        <div className="cx-flex">
          <p className="cx-text-left cx-text-xs cx-text-text-secondary cx-font-light cx-w-full cx-break-words">
            {licensingAuthority}
          </p>
        </div>
        <div className="cx-flex">
          <p className="cx-text-left cx-text-xs cx-text-text-secondary cx-font-light cx-w-full cx-break-words">
            {licenseNumber}
          </p>
        </div>
      </div>
      <div className="cx-flex cx-flex-col cx-items-center cx-shrink-0">
        <div className="cx-flex cx-items-center">
          <ArrowIcon className="cx-text-brand-primary-regular cx-w-11/12 cx-h-11/12" />
        </div>
      </div>
    </div>
  );
};

export default CompanyProfileCard;
